import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import SoftPhone from '../components/softPhone';
function SoftPhonePage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <SoftPhone />
        <Footer />
      </div>
    );
  }

 export default SoftPhonePage; 
  
  